import { render } from "./StudioInfoW.vue?vue&type=template&id=2e05add8&scoped=true"
import script from "./StudioInfoW.vue?vue&type=script&lang=js"
export * from "./StudioInfoW.vue?vue&type=script&lang=js"

import "./StudioInfoW.vue?vue&type=style&index=0&id=2e05add8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e05add8"]])

export default __exports__